import actions from './actions'
import mutations from './mutations'

const referrals = {
    namespaced: true,
    state: {
        numberOfBusinesses: null,
        numberOfClients: null,
        codes: [],
        filters: {
            clientId: null,
            leader: null,
            business: null,
            referralCode: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: new Date().toISOString().split('T')[0]
        },
        referrals: [],
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        isLoaded: false
    },
    mutations,
    actions
}

export default referrals
